import { render, staticRenderFns } from "./FundWallet.vue?vue&type=template&id=2bc755f9&scoped=true"
import script from "./FundWallet.vue?vue&type=script&lang=js"
export * from "./FundWallet.vue?vue&type=script&lang=js"
import style0 from "./FundWallet.vue?vue&type=style&index=0&id=2bc755f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc755f9",
  null
  
)

export default component.exports